import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@material-ui/core';
import Utils, { getFullNameOfUser } from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function McpCatalogVersionHistory({ versions, hasMore, isLoadingMore, onLoadMore }) {
    useTranslationSubscription();
    const [isExpanded, setIsExpanded] = useState(false);

    if (!versions || versions.length === 0) {
        return null;
    }

    return (
        <div className="mcp-catalog-version-history">
            <div
                className="accordionHead-SettingTitle"
                onClick={() => setIsExpanded(prev => !prev)}
            >
                <span className="text">{trI18n('MCP_CATALOG_VERSION_HISTORY_TITLE')}</span>
                {isExpanded ? (
                    <img src="/static/media/icon-minus-accordion.24e40269.svg" alt="minus" />
                ) : (
                    <img src="/static/media/icon-plus-accordion.d9a73563.svg" alt="plus" />
                )}
            </div>

            {isExpanded && (
                <div className="mcp-catalog-version-history-body">
                    <table className="mcp-catalog-version-history-table">
                        <thead>
                            <tr>
                                <th>{trI18n('MCP_CATALOG_VERSION_COL_VERSION')}</th>
                                <th>{trI18n('MCP_CATALOG_VERSION_COL_DATE')}</th>
                                <th>{trI18n('MCP_CATALOG_VERSION_COL_UPDATED_BY')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {versions.map((version, index) => (
                                <tr key={index}>
                                    <td>{version.version}</td>
                                    <td>{Utils.formatDateTime(version.date, 'YYYY/MM/DD')}</td>
                                    <td>
                                        {getFullNameOfUser(
                                            Constant.LANGUAGE_TYPE.JP,
                                            version.updatedBy
                                        ).trim()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {hasMore && (
                        <Box
                            className="mcp-catalog-version-history-seemore"
                            data-cy="mcp-catalog-version-history-seemore"
                        >
                            {isLoadingMore ? (
                                <CircularProgress
                                    size={14}
                                    thickness={4}
                                    style={{ verticalAlign: 'middle', marginRight: 6 }}
                                />
                            ) : null}
                            <span
                                style={{ cursor: isLoadingMore ? 'default' : 'pointer' }}
                                onClick={() => {
                                    if (!isLoadingMore && onLoadMore) {
                                        onLoadMore();
                                    }
                                }}
                            >
                                {trI18n('SEE_MORE')}
                            </span>
                        </Box>
                    )}
                </div>
            )}
        </div>
    );
}

McpCatalogVersionHistory.propTypes = {
    versions: PropTypes.arrayOf(
        PropTypes.shape({
            version: PropTypes.string.isRequired,
            date: PropTypes.string.isRequired,
            updatedBy: PropTypes.object
        })
    ),
    /** True when the backend returned a pagination cursor (more pages available) */
    hasMore: PropTypes.bool,
    /** True while a See More API request is in flight */
    isLoadingMore: PropTypes.bool,
    /** Callback to request the next page */
    onLoadMore: PropTypes.func
};

McpCatalogVersionHistory.defaultProps = {
    versions: [],
    hasMore: false,
    isLoadingMore: false,
    onLoadMore: null
};
